/**
 * Product Details Drawer.
 * i.e. used in Monitoring Plans System Drawer, Product Pages, Quiz, and Build My System.
 * Value is the **SFCC product id** (Sanity `id` field).
 */
export const PRODUCT_DRAWER_QUERY_PARAM = "productDetails";
